import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import { amountToCopCurrency } from "../../helpers/numberUtils";
import {
  setValuesRentSlider,
  setValuesBuySlider,
  setSelectedRentBuy,
  startGetAvailablePropertyTypes,
  startGetAvailablePlaces,
  setSelectedPlace,
  setSelectedPropertyType,
} from "../../actions/ui";
import { AppRoutes } from "../../routes";
import { useNavigate } from "react-router-dom";

export default function SearchTool(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showRent = useSelector((state) => state.ui.rentSlider.show);
  const showBuy = useSelector((state) => state.ui.buySlider.show);
  const minValueRent = useSelector((state) => state.ui.rentSlider.minValue);
  const maxValueRent = useSelector((state) => state.ui.rentSlider.maxValue);
  const minValueBuy = useSelector((state) => state.ui.buySlider.minValue);
  const maxValueBuy = useSelector((state) => state.ui.buySlider.maxValue);
  const selectedRentBuy = useSelector((state) => state.ui.selectedRentBuy);

  const selectedPropertyType = useSelector(
    (state) => state.ui.selectedPropertyType
  );
  const availablePropertyType = useSelector(
    (state) => state.ui.availablePropertyType
  );

  const selectedPlace = useSelector((state) => state.ui.setSelectedPlace);
  const availablePlaces = useSelector((state) => state.ui.availablePlaces);

  const onChangeSliderRent = (event) => {
    dispatch(setValuesRentSlider(event[0], event[1]));
  };

  const onChangeSliderBuy = (event) => {
    dispatch(setValuesBuySlider(event[0], event[1]));
  };

  const onChangeRentBuy = (event) => {
    const value = event.currentTarget.value;
    dispatch(setSelectedRentBuy(value));
  };

  const onChangePlace = (event) => {
    const value = event.currentTarget.value;
    dispatch(setSelectedPlace(value));
  };

  const onChangePropertyType = (event) => {
    const value = event.currentTarget.value;
    dispatch(setSelectedPropertyType(value));
  };

  const onSearch = () => {
    navigate(AppRoutes.PROPERTIES);
  };

  useEffect(() => {
    dispatch(startGetAvailablePlaces());
    dispatch(startGetAvailablePropertyTypes());
  }, []);

  return (
    <div className="col-lg-4" id="div_properties_search">
      <div className="card card-inverse no-border no-radius">
        <div className="card-body py-5 px-4">
          <h3 className="heading heading-5 strong-500 text-capitalize">
            Busca tu propiedad
          </h3>
          <h4 className="heading heading-sm strong-400 text-normal c-gray-light">
            Tu sueño esta cerca de volverse realidad
          </h4>
          <Form.Select
            aria-label="Que inmueble buscas?"
            onChange={onChangePropertyType}
            value={selectedPropertyType ?? ""}
          >
            <option value="">Que buscas...</option>
            {availablePropertyType?.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            aria-label="Donde lo buscas?"
            onChange={onChangePlace}
            value={selectedPlace ?? ""}
          >
            <option value="">Donde lo buscas...</option>
            {availablePlaces?.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            aria-label="selecciona rentar o comprar"
            onChange={onChangeRentBuy}
            value={selectedRentBuy ?? ""}
          >
            <option value="">Arrendar o comprar...</option>
            <option value="rent">Arrendar</option>
            <option value="buy">Comprar</option>
          </Form.Select>
          {showRent && (
            <div className="rent-slider custom-slider" hi>
              <Nouislider
                range={{ min: 900000, max: 7000000 }}
                start={[1800000, 3500000]}
                step={100000}
                connect
                onUpdate={onChangeSliderRent}
              />
              <div className="row">
                <div className="col-6">{amountToCopCurrency(minValueRent)}</div>
                <div className="col-6 text-right">
                  {amountToCopCurrency(maxValueRent)}
                </div>
              </div>
            </div>
          )}

          {showBuy && (
            <div className="buy-slider custom-slider">
              <Nouislider
                range={{ min: 60000000, max: 1000000000 }}
                start={[200000000, 650000000]}
                step={5000000}
                connect
                onUpdate={onChangeSliderBuy}
              />
              <div className="row">
                <div className="col-6">{amountToCopCurrency(minValueBuy)}</div>
                <div className="col-6 text-right">
                  {amountToCopCurrency(maxValueBuy)}
                </div>
              </div>
            </div>
          )}
          <button onClick={onSearch}>Buscar</button>
        </div>
      </div>
    </div>
  );
}
